export default "__VITE_ASSET__BYcSHDPC__"